//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

export enum CreatorListSort {
  FOLLOWERS = 'Most Followers',
  POSTS_FT_BRAND = 'Most Posts ft. My Brand',
  FOLLOWER_ENG_RATE = 'Highest Follower Eng. Rate',
  AVG_EMV = 'Highest Avg. EMV',
}
